import { Service, inject } from '@angular/core'
import {
  AddCustomersToGroupBody,
  ManagedCustomerGroup,
  RemoveCustomersFromGroupQuery,
  CreateCustomerGroupBody,
  EditCustomerGroupBody,
  GetCustomerGroupsResponse,
  DeleteEntityResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageCustomerGroupApiService {
  private readonly api = inject(ApiService)

  getCustomerGroups(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetCustomerGroupsResponse>(`manage/entities/${entityId}/customer-groups`, {
      ...init,
    })
  }

  getCustomerGroup(entityId: string, customerGroupId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedCustomerGroup>(
      `manage/entities/${entityId}/customer-groups/${customerGroupId}`,
      { ...init },
    )
  }

  createCustomerGroup(entityId: string, body: CreateCustomerGroupBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedCustomerGroup>(`manage/entities/${entityId}/customer-groups`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editCustomerGroup(entityId: string, customerGroupId: string, body: EditCustomerGroupBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedCustomerGroup>(
      `manage/entities/${entityId}/customer-groups/${customerGroupId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  deleteCustomerGroup(entityId: string, customerGroupId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(
      `manage/entities/${entityId}/customer-groups/${customerGroupId}`,
      {
        method: 'DELETE',
        ...init,
      },
    )
  }

  addCustomersToGroup(entityId: string, customerGroupId: string, body: AddCustomersToGroupBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedCustomerGroup>(
      `manage/entities/${entityId}/customer-groups/${customerGroupId}/customers`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  removeCustomersFromGroup(
    entityId: string,
    customerGroupId: string,
    query: RemoveCustomersFromGroupQuery,
    init?: RequestInit,
  ) {
    const url = this.api.createURL(`manage/entities/${entityId}/customer-groups/${customerGroupId}/customers`)
    url.search = this.api.toQueryParams(query)
    return this.api.protectedFetchJson<ManagedCustomerGroup>(url, {
      method: 'DELETE',
      ...init,
    })
  }
}
